import styled from 'styled-components'
import { MOBILE } from '../../constants/breakpoints'

export const ImgComp = styled.img`
    width: 300px;
    @media (max-width: ${MOBILE}px) {
        width: 280px;
    }
`
export const BtnComp = styled.button`
    height: 350px;
    background: #ffd550;
    border-radius: 12px;
    width: 416px;
    height: 47.5px;
    border: none;
    font-weight: 800;
    font-size: 16px;
    line-height: 22px;
    cursor: pointer;
    margin-top: 30px;

    @media (max-width: ${MOBILE}px) {
        width: 100%;
    }
`